import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';

const Pengajuan = ({
  number, nama, namaKegiatan, url,
}) => (
  <tr>
    <td className="capitalize">
      {' '}
      {number}
      {' '}
    </td>
    <td className="capitalize">
      {nama}
      {' '}
    </td>
    <td>
      {' '}
      {namaKegiatan}
      {' '}
    </td>
    <td className="capitalize">
      <Button className="btnDetail" href={url}>
        Lihat
      </Button>
    </td>
  </tr>
);

Pengajuan.propTypes = {
  number: PropTypes.number,
  namaKegiatan: PropTypes.string,
  nama: PropTypes.string,
  url: PropTypes.string,
};

Pengajuan.defaultProps = {
  number: 0,
  namaKegiatan: '',
  nama: '',
  url: '',
};

export default Pengajuan;
